// assets/cinematic-hero.js
// Scroll-sync hero — seek sérialisé (obligatoire Android Chrome / Samsung).
// Fallback soft-play si le décodeur Android n'arrive pas à suivre.
(function () {
  var tries = 0;

  function isAndroid() {
    return /Android/i.test(navigator.userAgent || '');
  }

  // iPhone / iPod always get the vertical mobile reel — including landscape
  // (CSS width often > 767px) and "Request Desktop Website" (UA reports Mac).
  function isIPhoneLike() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPod/i.test(ua)) return true;
    // iOS 13+ desktop-site mode: Macintosh UA + touch. Phones have short side ≤ ~500 CSS px.
    if ((navigator.platform === 'MacIntel' || /Macintosh/i.test(ua)) && (navigator.maxTouchPoints || 0) > 1) {
      var shortSide = Math.min(screen.width || 0, screen.height || 0);
      if (shortSide > 0 && shortSide <= 500) return true;
    }
    return false;
  }

  function preferMobileVideo() {
    if (isIPhoneLike()) return true;
    if (/Android/i.test(navigator.userAgent || '') && /Mobile/i.test(navigator.userAgent || '')) return true;
    if (window.matchMedia('(max-width:767px)').matches) return true;
    // Phone landscape fallback: short viewport height + coarse pointer
    if (window.matchMedia('(max-height:500px) and (orientation: landscape) and (hover: none)').matches) {
      return true;
    }
    return false;
  }

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if (tries++ < 60) return setTimeout(init, 50);
      document.querySelectorAll('.dx-cine').forEach(function (root) {
        root.classList.add('is-playing');
        root.querySelectorAll('.dx-cine__line, .dx-cine__cta').forEach(function (el) {
          el.classList.add('is-on');
        });
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.dx-cine').forEach(function (root) {
      var sticky = root.querySelector('.dx-cine__sticky');
      var track  = root.querySelector('.dx-cine__track');
      var video  = root.querySelector('.dx-cine__video');
      var lines  = root.querySelectorAll('.dx-cine__line, .dx-cine__cta');
      var isMobile = preferMobileVideo();
      var reduce   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var android  = isAndroid();

      root.classList.add(isMobile ? 'is-phone' : 'is-desktop');

      var src;
      if (android && root.dataset.videoAndroid) {
        src = root.dataset.videoAndroid;
      } else if (isMobile) {
        src = root.dataset.videoMobile;
      } else {
        src = root.dataset.videoDesktop;
      }
      var posterSrc = isMobile
        ? (root.dataset.posterMobile || root.dataset.posterDesktop)
        : root.dataset.posterDesktop;
      if (!src) return;

      if (android) video.setAttribute('preload', 'auto');

      video.src = src;
      if (posterSrc) video.setAttribute('poster', posterSrc);
      video.load();
      var poster = root.querySelector('.dx-cine__poster');
      if (poster && posterSrc) poster.src = posterSrc;

      var overlayStates = Array.from(lines).map(function (el) {
        return {
          el: el,
          from: parseFloat(el.dataset.from || '0'),
          to: parseFloat(el.dataset.to || '100'),
          on: false
        };
      });

      function updateOverlays(pct) {
        overlayStates.forEach(function (state) {
          var shouldOn = pct >= state.from && pct <= state.to;
          if (shouldOn === state.on) return;
          state.on = shouldOn;
          if (shouldOn) state.el.classList.add('is-on');
          else state.el.classList.remove('is-on');
        });
      }

      if (reduce) {
        root.classList.add('is-playing');
        lines.forEach(function (el) { el.classList.add('is-on'); });
        return;
      }

      updateOverlays(0);

      function start() {
        var duration = video.duration || 25;
        var fps = android ? 8 : (isMobile ? 16 : 24);
        var frame = 1 / fps;
        var lastOverlayPct = -1;
        var scrollIdleTimer = 0;
        var targetTime = 0;
        var seeking = false;
        var started = false;
        var softMode = false;
        var seekSamples = [];
        var seekStartedAt = 0;
        var softRaf = 0;

        function markScrolling() {
          root.classList.add('is-scrolling');
          clearTimeout(scrollIdleTimer);
          scrollIdleTimer = setTimeout(function () {
            root.classList.remove('is-scrolling');
          }, 140);
        }

        function enterSoftMode() {
          if (softMode) return;
          softMode = true;
          root.classList.add('is-soft-play');
          // Lecture liée au scroll via playbackRate, sans seek agressif.
          video.playbackRate = 1;
        }

        function softSync() {
          if (!softMode) return;
          softRaf = 0;
          var desired = targetTime;
          var cur = video.currentTime;
          var delta = desired - cur;

          if (Math.abs(delta) < 0.12) {
            if (!video.paused) video.pause();
            return;
          }

          // Gros écart : un seul seek (rare), sinon accélérer/ralentir.
          if (Math.abs(delta) > 1.8) {
            try {
              video.currentTime = desired;
            } catch (e) {}
            if (!video.paused) video.pause();
            return;
          }

          video.playbackRate = Math.max(0.5, Math.min(2.2, 1 + delta * 1.4));
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        }

        function scheduleSoft() {
          if (softRaf) return;
          softRaf = requestAnimationFrame(softSync);
        }

        function applySeek() {
          if (softMode) {
            scheduleSoft();
            return;
          }
          if (seeking) return;
          var t = targetTime;
          if (Math.abs(t - video.currentTime) < frame * 0.6) return;
          seeking = true;
          seekStartedAt = performance.now();
          try {
            video.currentTime = t;
            if (!started) {
              started = true;
              root.classList.add('is-playing');
            }
          } catch (e) {
            seeking = false;
          }
        }

        video.addEventListener('seeked', function () {
          seeking = false;
          if (seekStartedAt) {
            seekSamples.push(performance.now() - seekStartedAt);
            seekStartedAt = 0;
            if (seekSamples.length > 8) seekSamples.shift();
            // Si les seeks dépassent ~90 ms en moyenne → soft mode.
            if (android && seekSamples.length >= 4) {
              var avg = seekSamples.reduce(function (a, b) { return a + b; }, 0) / seekSamples.length;
              if (avg > 90) enterSoftMode();
            }
          }
          if (!softMode && Math.abs(targetTime - video.currentTime) >= frame * 0.6) {
            applySeek();
          }
        });

        video.addEventListener('error', function () { seeking = false; });
        video.addEventListener('playing', function () {
          if (!started) {
            started = true;
            root.classList.add('is-playing');
          }
        });

        // Sur Android, démarrer directement en soft mode :
        // le seek MediaCodec saccade quasi toujours sur Chrome Samsung.
        if (android) enterSoftMode();

        ScrollTrigger.create({
          trigger: sticky,
          start: 'top top',
          end: function () { return '+=' + (track.offsetHeight - window.innerHeight); },
          scrub: android ? 0.8 : (isMobile ? 0.25 : true),
          onUpdate: function (self) {
            var p = self.progress;
            targetTime = Math.round(p * duration * fps) / fps;
            markScrolling();
            applySeek();
            var pct = p * 100;
            if (Math.abs(pct - lastOverlayPct) >= 0.5) {
              updateOverlays(pct);
              lastOverlayPct = pct;
            }
          },
          onLeave: function () {
            if (!video.paused) video.pause();
          },
          onLeaveBack: function () {
            if (!video.paused) video.pause();
          }
        });

        ScrollTrigger.refresh();
      }

      function ready() {
        if (video.readyState >= 1) start();
        else video.addEventListener('loadedmetadata', start, { once: true });
      }

      if (android) {
        var buffered = false;
        function onBuffer() {
          if (buffered) return;
          if (video.buffered.length && video.buffered.end(0) > 1) {
            buffered = true;
            ready();
          }
        }
        video.addEventListener('progress', onBuffer);
        video.addEventListener('canplay', function () {
          if (!buffered) { buffered = true; ready(); }
        }, { once: true });
        setTimeout(function () { if (!buffered) { buffered = true; ready(); } }, 2500);
      } else {
        ready();
      }

      var unlock = video.play();
      if (unlock && unlock.then) unlock.then(function () { video.pause(); }).catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
